import { ContentType, EmptyResponse, ErrorResponse } from 'api/types'
import { request } from 'api/utils'
import { EnvironmentVariablesService } from 'utils/env'
import { PATH } from './constants'
import { DocumentsResponse, DocumentsStatus, DocumentType } from './types'
import { addQueryString } from 'utils/addQueryString'

export class DocumentsApi {
  public baseUrl = EnvironmentVariablesService.getEnv('REACT_APP_API_URL') || ''

  async uploadDocuments(formData: FormData) {
    return request<EmptyResponse, ErrorResponse>(
      this.baseUrl,
      PATH.DOCUMENTS,
      { method: 'POST' },
      formData,
      'json',
      ContentType.FORM_DATA
    )
  }

  async getDocuments(companyId: string) {
    return request<DocumentsResponse, ErrorResponse>(
      this.baseUrl,
      addQueryString(PATH.DOCUMENTS, {
        companyId,
      })
    )
  }

  async setDocumentsStatus(companyId: string, newStatus: DocumentsStatus) {
    return request<void, ErrorResponse>(
      this.baseUrl,
      `company/${companyId}/documents/status`,
      { method: 'POST' },
      { newStatus }
    )
  }

  async downloadAllDocuments(
    documentType: keyof typeof DocumentType,
    date: string,
    companyId?: number
  ) {
    return request<string, ErrorResponse>(
      this.baseUrl,
      'company/documentsDownload',
      {
        method: 'POST',
        headers: { Accept: 'application/zip, application/x-zip-compressed' },
      },
      { companyId, documentType, date },
      'blob'
    )
  }
}

export const documentsApi = new DocumentsApi()
